module.exports = __webpack_public_path__ + "static/img/icon_anquan.77071707.svg";